export default (kasko) => {
  kasko.addEventListener(
    'route-changed',
    ({ current }) => {
      const optinPages = ['common-optin', 'private-liability-optin', 'optin', 'buildings-optin'];

      if (!optinPages.includes(current.path)) return;

      const {
        lead_agent_email,
        lead_agent_first_name,
        lead_agent_last_name,
        lead_agent_company,
        lead_agent_number,
        lead_first_name,
        lead_last_name,
      } = kasko.getState('input');

      lead_agent_email &&
        kasko.dispatchEvent('set-form-input', {
          agent_email: lead_agent_email,
        });
      lead_agent_first_name &&
        kasko.dispatchEvent('set-form-input', {
          agent_first_name: lead_agent_first_name,
        });
      lead_agent_last_name &&
        kasko.dispatchEvent('set-form-input', {
          agent_last_name: lead_agent_last_name,
        });
      lead_agent_company &&
        kasko.dispatchEvent('set-form-input', {
          agent_company: lead_agent_company,
        });
      lead_agent_number &&
        kasko.dispatchEvent('set-form-input', {
          agent_number: lead_agent_number,
        });
      lead_first_name &&
        kasko.dispatchEvent('set-form-input', {
          first_name: lead_first_name,
        });
      lead_last_name &&
        kasko.dispatchEvent('set-form-input', {
          last_name: lead_last_name,
        });
    },
    {
      slice: 'flags.lead_retrieved',
    },
  );
};
